import { render, staticRenderFns } from "./UITreeView.vue?vue&type=template&id=1db464dd"
import script from "./UITreeView.vue?vue&type=script&lang=js"
export * from "./UITreeView.vue?vue&type=script&lang=js"
import style0 from "./UITreeView.vue?vue&type=style&index=0&id=1db464dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports